import { render, staticRenderFns } from "./PayMessageCard.vue?vue&type=template&id=ee4bdac2&scoped=true&"
import script from "./PayMessageCard.vue?vue&type=script&lang=js&"
export * from "./PayMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./PayMessageCard.vue?vue&type=style&index=0&id=ee4bdac2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4bdac2",
  null
  
)

export default component.exports